export default __webpack_public_path__ + "static/media/LogoOeschle.82467576.svg";